// cross browsers addRule method
import { raf } from './raf.js';
export function removeCSSRule(sheet, index) {
  // return raf(function() {
    'deleteRule' in sheet ?
      sheet.deleteRule(index) :
      sheet.removeRule(index);
  // });
}


//////////////////
// WEBPACK FOOTER
// /Users/maciejwarych/Local Sites/vidoq/app/public/wp-content/themes/vidoq/node_modules/tiny-slider/src/helpers/removeCSSRule.js
// module id = 28
// module chunks = 0